__turbopack_context__.v({
  "container": "NavBlogCard-module-scss-module__yrcnJa__container",
  "content": "NavBlogCard-module-scss-module__yrcnJa__content",
  "image": "NavBlogCard-module-scss-module__yrcnJa__image",
  "imageWrapper": "NavBlogCard-module-scss-module__yrcnJa__imageWrapper",
  "title": "NavBlogCard-module-scss-module__yrcnJa__title",
});
